import { Form, Input, Button, Space, Radio, Row, Col } from 'antd'
import { ReloadOutlined, SearchOutlined } from '@ant-design/icons'
import StoreSelectBase from '../../../components/BaseInfoSelects/StoreSelectBase'
import TimeDurationFormItem from '../../../components/TimeDurationFormItem'
import AuthComponent from '../../../components/AuthComponent'
import useProcurementTypeContext from '../hooks/useProcurementTypeContext'
import { useMemo, useEffect } from 'react'
import SupplierSelect from '../../../components/BaseInfoSelects/SupplierSelect'
import { useState } from 'react'
import { procurementTypeFundStatus } from '../config'
const basic = {
  storeId: null,
  purchaseOrderNo: null,
  duration: [null, null],
  supplierId: null,
  fundStatus: ''
}
const rowStyle = {
  // margin: '10px 0'
}
const basicDurationKeys = ['startCreateTime', 'endCreateTime']
export default function ProcurementBasicForm({
  queryNewData,
  initVals,
  children
}) {
  const [form] = Form.useForm()
  const { isOrder, procurementType, baseKey, purchaseOrderNo } = useProcurementTypeContext()
  const [defaultVal, setDefaultVal] = useState({})
  const [haveDefaultVal, setHaveDefaultVal] = useState(false)
  const initFormValue = useMemo(() => {
    return {
      ...basic,
      ...initVals,
      purchaseStatus: null
    }
  }, [initVals, isOrder])
  const confirm = async () => {
    await form.validateFields()
    let formData = form.getFieldsValue()
    delete formData.duration
    queryNewData(formData)
  }
  const setDefaultFormVal = data => {
    setDefaultVal({ ...form.getFieldsValue(), ...data })
  }
  const OnOptionsLoad = res => {
    form.setFieldsValue({ storeId: res.id })
    setDefaultFormVal({ storeId: res.id })
    setHaveDefaultVal(true)
  }
  form.setFieldsValue({purchaseOrderNo: purchaseOrderNo})
  // const OnSupplierOptionsLoad = res => {
  //   const supplierId = (res && res[0].supplierId) || ""
  //   form.setFieldsValue({ supplierId })
  //   setDefaultFormVal({ supplierId })
  // }
  useEffect(() => {
    confirm()
    return () => {}
  }, [haveDefaultVal, procurementType, purchaseOrderNo])
  return (
    <>
      <Form
        form={form}
        layout='inline'
        initialValues={initFormValue}
        className='basic-form'
        wrapperCol={{ style: { marginBottom: 20 } }}
        labelCol={{ style: { width: 90, textAlign: 'right' } }}>
        {/* <Row style={rowStyle} justify='space-between'>
          <Col span={7}> */}
        <Form.Item
          label='所属门店'
          name='storeId'
          rules={[{ required: true, message: '请选择所属门店' }]}>
          <StoreSelectBase
            keyVal='id'
            style={{ width: '160px' }}
            OnOptionsLoad={OnOptionsLoad}
          />
        </Form.Item>
        {/* </Col>
          <Col span={7}> */}
        <Form.Item label='采购单号' name='purchaseOrderNo'>
          <Input placeholder='请输入' />
        </Form.Item>
        {/* </Col>
          <Col span={10}> */}
        <TimeDurationFormItem
          label='创建时间'
          keys={basicDurationKeys}
          form={form}
        />
        {/* </Col>
        </Row>
        <Row style={rowStyle}>
          <Col span={7}> */}
        <Form.Item label='所属供应商' name='supplierId'>
          <SupplierSelect style={{ width: '160px' }} />
        </Form.Item>
        {/* </Col>
          <Col span={7}> */}
        <Form.Item
          label={!isOrder ? '退货单状态' : '采购单状态'}
          name='purchaseStatus'>
          <Radio.Group>
            <Radio value={null}>全部</Radio>
            {!isOrder ? (
              <Radio value={2}>已退货</Radio>
            ) : (
              <Radio value={1}>已收货</Radio>
            )}
            <Radio value={0}>已作废</Radio>
          </Radio.Group>
        </Form.Item>
        {/* </Col>
          <Col span={10}> */}
        <Form.Item label={!isOrder ? '退款状态' : '付款状态'} name='fundStatus'>
          <Radio.Group>
            <Radio value={''}>全部</Radio>
            {procurementTypeFundStatus[procurementType].map(item => (
              <Radio key={item.value} value={item.value}>
                {item.key}
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
        {/* </Col>
        </Row> */}
        {/* <Row style={rowStyle}>
        </Row> */}
      </Form>
      <div className='basic-form-btns'>
        <Space>
          <AuthComponent authKey={baseKey + 'list'}>
            <Button
              type='primary'
              ghost
              onClick={confirm}
              icon={<SearchOutlined />}>
              查询
            </Button>
          </AuthComponent>
          <Button
            type='primary'
            ghost
            icon={<ReloadOutlined />}
            onClick={() => form.resetFields()}>
            重置
          </Button>
          {children}
        </Space>
      </div>
    </>
  )
}
